import { useParams } from "react-router";

import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { showCancelScanRunModal } from "shared/Scan/CancelScanRunModal";
import { showStopScanRunModal } from "shared/Scan/StopScanRunModal";
import useCancelScanRun from "shared/Scan/useCancelScanRun";
import useStopScanRun from "shared/Scan/useStopScanRun";

import { GET_SCAN_DETAIL } from "../../../../gql";
import { SEARCH_SCAN_RUNS, SEARCH_SCAN_RUNS_COUNT } from "../../../gql";
import { ScanRunsListItem } from "../../../types";

const ScanRunsTableSettingsCell = ({
  item: scanRun,
  ...cellProps
}: TableSimpleCellProps<ScanRunsListItem>) => {
  const { scanId = "" } = useParams<{ scanId: string }>();
  const { canCancel, showCancel } = useCancelScanRun({ scanRun });
  const { canStop, showStop } = useStopScanRun({ scanRun });

  const refetchQueries = [
    { query: GET_SCAN_DETAIL, variables: { id: scanId } },
    SEARCH_SCAN_RUNS,
    SEARCH_SCAN_RUNS_COUNT,
  ];

  if (!showCancel && !showStop) {
    return <TableSimpleCell {...cellProps} />;
  }

  return (
    <TableSimpleCell {...cellProps}>
      <DropdownMenuEllipsis tooltip="Scan run actions">
        {showCancel && (
          <DropdownMenuItem
            onAction={() => showCancelScanRunModal({ scanRun, refetchQueries })}
            isDisabled={!canCancel.result}
            tooltip={canCancel.message}
            tooltipPlacement="left"
          >
            Cancel
          </DropdownMenuItem>
        )}
        {showStop && (
          <DropdownMenuItem
            onAction={() => showStopScanRunModal({ scanRun, refetchQueries })}
            isDisabled={!canStop.result}
            tooltip={canStop.message}
            tooltipPlacement="left"
          >
            Stop
          </DropdownMenuItem>
        )}
      </DropdownMenuEllipsis>
    </TableSimpleCell>
  );
};

export default ScanRunsTableSettingsCell;
